"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ONLINE_STORE_RANGE_TIME = exports.DEFAULT_ONLINE_STORE_ACCENT_COLOR = exports.DEFAULT_ONLINE_STORE_CLOSE_TIME = exports.DEFAULT_ONLINE_STORE_OPEN_TIME = exports.SELECT_ALL = exports.DEFAULT_RECEIPT_TEMPLATE = void 0;
const enums_1 = require("../enums");
exports.DEFAULT_RECEIPT_TEMPLATE = 'DEFAULT';
exports.SELECT_ALL = 'SELECT_ALL';
exports.DEFAULT_ONLINE_STORE_OPEN_TIME = '07:00';
exports.DEFAULT_ONLINE_STORE_CLOSE_TIME = '23:59';
exports.DEFAULT_ONLINE_STORE_ACCENT_COLOR = '#2684fc';
exports.DEFAULT_ONLINE_STORE_RANGE_TIME = [
    {
        isActive: true,
        day: enums_1.DayOfWeek.SUNDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.MONDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.TUESDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.WEDNESDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.THURSDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.FRIDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
    {
        isActive: true,
        day: enums_1.DayOfWeek.SATURDAY,
        timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
    },
];
//# sourceMappingURL=stores.js.map